/*
 * サブシステム名：
 * 機能名：配車表入力
 * 表示項目カスタマイズ(日伸)
 */
import D2PLMD1010 from '@/views/PLM/D2PLMD1010.js'
import date from '@/ddv2.library/date'

export default {
  extends: D2PLMD1010,
  name: 'HaishaMeisaiListEditCustomForNsn',
  data: () => ({
    unkoYmdMultiFlg: true,
    conditionDetails: [
      { key: 'unkoYmdFromTo', name: '運行日', value: 'unkoYmdFromTo', delete: false },
      { key: 'haishahyoCd', name: '配車表', value: 'haishahyoNm', delete: true },
      { key: 'haishaEigyoshoId', name: '配車営業所', value: 'haishaEigyoshoNm', delete: true },
      { key: 'sharyoId', name: '車両', value: 'sharyoNm', delete: true },
      { key: 'jininId1', name: '乗務員', value: 'jininNm1', delete: true },
      { key: 'mstHinmeiId', name: '品名', value: 'mstHinmeiNm', delete: true }
      // { key: 'tableStartHourDisp', name: '開始時間', value: 'tableStartHourDisp', delete: false },
      // { key: 'rangeDisp', name: '表示範囲', value: 'rangeDisp', delete: false }
    ]
  }),
  computed: {
  },
  methods: {
    /**
     * スプレッドシート変更後イベント
     * @param {*} rowData
     * @param {*} cell
     * @param {*} x
     * @param {*} y
     * @param {*} newValue
     * @param {*} oldValue
     */
    changeAfter (rowData, cell, x, y, newValue, oldValue) {
      // console.log('c', rowData, cell, x, y, newValue, oldValue)
      const col = Number(x)
      const row = Number(y)
      if (Number(x) === this.computedColNumList.haishaKbnNm) {
        console.log('change After :', this.computedColNumList.jidoshaHyojiNm, this.computedColNumList.hacchusakiNm)
        // 配車先毎入力制御
        if (newValue === '自社') {
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.jidoshaHyojiNm, y, false)
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.hacchusakiNm, y, true)
        } else if (newValue === '傭車') {
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.jidoshaHyojiNm, y, true)
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.hacchusakiNm, y, false)
        }
      }
      if (Number(x) === this.computedColNumList.hinmeiNm) {
        const t = this.hinmeiList.filter((elem) => {
          return elem.kaishaCd === this.currentKaishaCode
        }).find(x => x.hinmeiNm === this.rows[y].hinmeiNm)
        if (t) {
          this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.tanka, Number(y)), t.tanka, true)
          this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.unchinKeisanKbnNm, Number(y)), t.unchinKeisanKbnNm, true)
        }
      }
      const needRecalcSeikyu = [
        this.computedColNumList.juchuSuryo,
        this.computedColNumList.tanka,
        this.computedColNumList.juchuSharyoSuryo
      ].includes(col)
      if (needRecalcSeikyu) {
        /*
          請求金額自動計算
        */
        if (this.computedColNumList.hinmokuKihonUnchin || this.computedColNumList.meisaiKihonUnchin) {
          const hinmoku = this.computedColNumList.hinmokuKihonUnchin ? 'hinmoku' : ''
          this.calcKihonUnchinByQuantity(Number(y), hinmoku)
        }
      }
      const needRecalcShiharai = [
        this.computedColNumList.juchuSuryo,
        this.computedColNumList.hacchuTanka,
        this.computedColNumList.hacchuSharyoSuryo
      ].includes(col)
      if (needRecalcShiharai) {
        /*
          支払金額自動計算
        */
        if (this.computedColNumList.hacchuHinmokuKihonUnchin || this.computedColNumList.hacchuMeisaiKihonUnchin) {
          const hinmoku = this.computedColNumList.hacchuHinmokuKihonUnchin ? 'hinmoku' : ''
          this.calcHacchuKihonUnchinByQuantity(row, hinmoku)
        }
      }
    },
    calcKihonUnchinByQuantity: function (y, hinmoku) {
      if (![undefined, null, ''].includes(this.rows[y].juchuSuryo) && ![undefined, null, ''].includes(this.rows[y].tanka) && ![undefined, null, ''].includes(this.rows[y].juchuSharyoSuryo)) {
        let cell
        const t = this.rows[y].juchuSuryo * this.rows[y].tanka * this.rows[y].juchuSharyoSuryo
        if (![undefined, null, ''].includes(hinmoku)) {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.hinmokuKihonUnchin, y)
        } else {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.meisaiKihonUnchin, y)
        }
        // ★ 既に同じ値なら setValue しない
        const current = this.$refs.ddSpreadSheet.jspreadsheetObj.getValue(cell)
        if (Number(current) === t) return
        this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, Math.round(t), true)
      }
    },
    calcHacchuKihonUnchinByQuantity: function (y, hinmoku) {
      if (![undefined, null, ''].includes(this.rows[y].juchuSuryo) && ![undefined, null, ''].includes(this.rows[y].hacchuTanka) && ![undefined, null, ''].includes(this.rows[y].hacchuSharyoSuryo)) {
        let cell
        const t = this.rows[y].juchuSuryo * this.rows[y].hacchuTanka * this.rows[y].hacchuSharyoSuryo
        if (![undefined, null, ''].includes(hinmoku)) {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.hacchuHinmokuKihonUnchin, y)
        } else {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.hacchuMeisaiKihonUnchin, y)
        }
        // ★ 既に同じ値なら setValue しない
        const current = this.$refs.ddSpreadSheet.jspreadsheetObj.getValue(cell)
        if (Number(current) === t) return
        this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, Math.round(t), true)
      }
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const d = new Date()
      const initConditions = {
        sagyoYoteiYmd: date.getCurrentDate(),
        sagyoYoteiYmdFrom: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        sagyoYoteiYmdTo: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        haishahyoCd: null,
        eigyoshoId: null,
        layoutType: 'D2PLMD1011'
      }
      this.conditions = {
        ...initConditions,
        // 表示用
        // unkoYmd: initConditions.sagyoYoteiYmd,
        unkoYmdFromTo: initConditions.sagyoYoteiYmdFrom + '～' + initConditions.sagyoYoteiYmdTo,
        haishahyoNm: null,
        haishaEigyoshoNm: null,
        sharyoNm: null,
        jomuinNm: null,
        tokuisakiNm: null,
        mstHinmeiNm: null
      }
      this.isAfterSearch = false
      this.haishaChohyoSbt = '0'
      this.nohinshoChohyoSbt = '99'
      this.searchText = ''
      this.rows = []
      this.page = 1
      this.unkoYmdMultiFlg = true
    }
  }
}
